import { api } from "../utils/api";
import type {
  RestClassifyDevice,
  RestDevice,
  RestUpdateDevice,
} from "@KassaroAB/shared/types/device";
import type { StoreId, DeviceId } from "@KassaroAB/shared/types/ids";

export const getDevicesApi = async (
  storeId: StoreId,
): Promise<RestDevice[]> => {
  return api.get(`stores/${storeId}/devices`);
};

export const getDeviceApi = async (
  storeId: StoreId,
  deviceId: DeviceId,
): Promise<RestDevice> => {
  return api.get(`stores/${storeId}/devices/${deviceId}`);
};

export const updateDeviceApi = async (
  storeId: StoreId,
  deviceId: DeviceId,
  device: RestUpdateDevice,
): Promise<RestDevice> => {
  return api.put(`stores/${storeId}/devices/${deviceId}`, device);
};

export const activateDeviceApi = async (
  storeId: StoreId,
  deviceId: DeviceId,
): Promise<RestDevice> => {
  return api.post(`stores/${storeId}/devices/${deviceId}/activate`, {});
};

export const deactivateDeviceApi = async (
  storeId: StoreId,
  deviceId: DeviceId,
): Promise<RestDevice> => {
  return api.post(`stores/${storeId}/devices/${deviceId}/deactivate`, {});
};

export const classifyDeviceApi = async (
  storeId: StoreId,
  deviceId: DeviceId,
  classification: RestClassifyDevice,
): Promise<RestDevice> => {
  return api.post(
    `stores/${storeId}/devices/${deviceId}/classify`,
    classification,
  );
};

